import angular from 'angular';
import totalLendingRequired from './totalLendingRequired';

export default angular
  .module('components.totalLendingRequired', [])
  .component('totalLendingRequired', totalLendingRequired).name;
